import React from 'react';
import { PinInputField } from '@chakra-ui/react';

const CodeInput = ({ ...props }) => {
    return (
        <PinInputField
            border='1px solid #A0AEC0'
            textAlign='center'
            borderRadius='6px'
            width='48px'
            h='48px'
            {...props}
        />
    );
};

export default CodeInput;
